"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Badge_1 = require("./Badge");
Object.defineProperty(exports, "Badge", { enumerable: true, get: function () { return Badge_1.Badge; } });
Object.defineProperty(exports, "badgeSizes", { enumerable: true, get: function () { return Badge_1.badgeSizes; } });
//# sourceMappingURL=index.js.map